export default __webpack_public_path__ + "static/media/empty-state-cart.3cd09678.svg";